import React from "react";
import { Breadcrumbs, HorizontalLinkGroup } from "components/navigation";
import { LinkButton } from "components/buttons";
import { CreditCount } from "../shared/credit-count";
import { Route, Routes, Navigate } from "react-router-dom";
import { GreyFleetOverview } from "pages/licence-checking/grey-fleet/overview";
import { SearchGreyFleetStats } from "./search-grey-fleet-stats";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Tooltip } from "components/tooltip";
import { Position } from "@blueprintjs/core";
import { NotificationInline } from "components/notifications";

export function GreyFleet({
    breadcrumbs = []
}) {
    const routes = [
        {
            location: "/licence-checking/grey-fleet/overview",
            title: "Overview",
        },
        {
            location: "/licence-checking/grey-fleet/checks?filter=NONE",
            title: "Grey Fleet Checks",
        },
    ];
    const licenceCredits = useSelector(
        (state) => state.licenceChecking.licenceCredits
    );
    const greyFleetCredits = useSelector(
        (state) => state.licenceChecking.greyFleetCredits
    );

    return (
        <div className="row">
            <Breadcrumbs items={breadcrumbs} />
            <h1>Grey Fleet Hub</h1>

            <NotificationInline
                text="You have run out of credits, until you have added more credits some data may be out of date and not processed. Please add more credits to resume functionality."
                intent="warning"
                show={greyFleetCredits <= 0 || licenceCredits <= 0}
            />

            <div className="inline-items inline-items-space-reverse spacer-bottom-large">
                <CreditCount from="greyfleet" />
                <div className="button-row button-row-stacked-mobile">
                    <div className="inline-items">
                        <LinkButton
                            text="grey fleet settings"
                            intent="primary"
                            href="/licence-checking/grey-fleet/settings"
                        />

                        {greyFleetCredits <= 0 ? (
                            <Tooltip
                                position={Position.TOP}
                                content="You do not have enough credits to create a new check. Please purchase more credits to proceed."
                            >
                                <LinkButton
                                    text="new check"
                                    intent="primary"
                                    href="/licence-checking/grey-fleet/create"
                                    disabled={true}
                                />
                            </Tooltip>
                        ) : (
                            <LinkButton
                                text="new check"
                                intent="primary"
                                href="/licence-checking/grey-fleet/create"
                            />
                        )}

                        <LinkButton
                            text="licence checking hub"
                            intent="primary"
                            href="/licence-checking"
                        />
                    </div>
                </div>
            </div>
            <div className="spacer-bottom">
                <HorizontalLinkGroup
                    links={routes}
                    exactRouteMatch={false}
                ></HorizontalLinkGroup>
            </div>

            <Routes>
                <Route path="overview" element={<GreyFleetOverview />} />
                <Route path="checks" element={<SearchGreyFleetStats />} />
                <Route path="" element={<Navigate to="/licence-checking/grey-fleet/overview" replace />} />
            </Routes>
        </div>
    );
}

GreyFleet.propTypes = {
    breadcrumbs: PropTypes.array,
};
